import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface DisclaimerModalProps {
  open: boolean;
  onAccept: () => void;
}

const DisclaimerModal = ({ open, onAccept }: DisclaimerModalProps) => {
  return (
    <Dialog open={open} onOpenChange={() => { }}>
      <DialogContent className="glass sm:max-w-lg max-h-[90vh] overflow-y-auto" onPointerDownOutside={(e) => e.preventDefault()}>
        {/* Button at the TOP to avoid being hidden by Lovable badge */}
        <div className="sticky top-0 bg-background/95 backdrop-blur-sm pt-2 pb-4 z-50 border-b border-border/50">
          <Button onClick={onAccept} className="w-full bg-primary hover:bg-primary/90 h-12 text-base font-semibold">
            ✓ I Agree & Continue
          </Button>
        </div>

        <DialogHeader className="text-center mt-2">
          <div className="mx-auto mb-4 p-3 rounded-full bg-warning/10 w-fit">
            <AlertTriangle className="h-8 w-8 text-warning" />
          </div>
          <DialogTitle className="text-2xl">Important Disclaimer</DialogTitle>
          <DialogDescription className="text-left mt-4 space-y-4">
            <p>
              Welcome to <strong>TAM Store</strong>! Before you continue, please read and acknowledge the following:
            </p>
            <ul className="list-disc pl-5 space-y-2 text-sm">
              <li>
                All tools and resources provided on this platform are for <strong>educational and personal use purposes only</strong>.
              </li>
              <li>
                You agree to use these tools responsibly and in compliance with all applicable laws and regulations.
              </li>
              <li>
                TAM Store is not responsible for any misuse of the tools or any consequences arising from their use.
              </li>
              <li>
                By continuing, you confirm that you are at least 18 years of age or have parental consent.
              </li>
            </ul>
            <p className="text-xs text-muted-foreground">
              By clicking the button above, you acknowledge that you have read, understood, and agree to abide by these terms.
            </p>
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};

export default DisclaimerModal;
